var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3335 5.00008V7.01675C18.3335 8.33341 17.5002 9.16675 16.1835 9.16675H13.3335V3.34175C13.3335 2.41675 14.0918 1.66675 15.0168 1.66675C15.9252 1.67508 16.7585 2.04175 17.3585 2.64175C17.9585 3.25008 18.3335 4.08341 18.3335 5.00008Z",
    stroke: "#010E20",
    strokeWidth: 1.24699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 5.83341V17.5001C1.6665 18.1917 2.44984 18.5834 2.99984 18.1668L4.42484 17.1001C4.75817 16.8501 5.22484 16.8834 5.52484 17.1834L6.90817 18.5751C7.23317 18.9001 7.7665 18.9001 8.0915 18.5751L9.4915 17.1751C9.78317 16.8834 10.2498 16.8501 10.5748 17.1001L11.9998 18.1668C12.5498 18.5751 13.3332 18.1834 13.3332 17.5001V3.33341C13.3332 2.41675 14.0832 1.66675 14.9998 1.66675H5.83317H4.99984C2.49984 1.66675 1.6665 3.15841 1.6665 5.00008V5.83341Z",
    stroke: "#010E20",
    strokeWidth: 1.24699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.5 10.8418H10",
    stroke: "#010E20",
    strokeWidth: 1.24699,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.5 7.5083H10",
    stroke: "#010E20",
    strokeWidth: 1.24699,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.99658 10.8335H5.00407",
    stroke: "#010E20",
    strokeWidth: 1.66265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.99607 7.49992H5.00356",
    stroke: "#010E20",
    strokeWidth: 1.66265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuInvoice);
export default __webpack_public_path__ + "static/media/menuInvoice.a974fb14476a56d182fe45804abfde6b.svg";
export { ForwardRef as ReactComponent };